module.exports = "<!-- <div class=\"footer\" >\r\n    <div>\r\n         <strong style=\"margin-top: 5% !important;\">Terrefort</strong> &copy; 2021 \r\n      </div>\r\n</div> -->\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/footer/footer.template.html
// module id = ./src/app/components/common/footer/footer.template.html
// module chunks = main